import React, { useState } from "react";
import { Check } from "lucide-react";

export default function ChecklistCard({ items }) {
  const [done, setDone] = useState({});
  return (
    <div className="bg-white rounded-[1.5rem] p-5 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-[#E8E8ED]" data-testid="checklist">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {items.map((it, i) => {
          const active = !!done[i];
          return (
            <button
              key={i}
              onClick={() => setDone((d) => ({ ...d, [i]: !d[i] }))}
              className="flex items-start gap-3 p-2 rounded-xl hover:bg-[#F5F5F7] text-left transition-colors"
              data-testid={`checklist-item-${i}`}
            >
              <span
                className={`mt-0.5 w-5 h-5 rounded-md border flex items-center justify-center flex-shrink-0 transition-colors ${
                  active ? "bg-[#15C3C6] border-[#15C3C6]" : "border-[#E8E8ED] bg-white"
                }`}
              >
                {active && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
              </span>
              <span className={`text-sm ${active ? "line-through text-gray-400" : "text-[#1D1D1F]"}`}>{it}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
